export const categories = [
  { slug: "wanghong", name: "网红黑料", icon: "ri-user-smile-line", description: "网红达人私密黑料大起底，一手独家爆料" },
  { slug: "wangbaomen", name: "网曝门", icon: "ri-door-open-line", description: "最新网曝门事件，热门吃瓜第一现场" },
  { slug: "chaoyang", name: "朝阳群众", icon: "ri-eye-line", description: "朝阳群众火眼金睛，明星八卦无所遁形" },
  { slug: "fanchabiao", name: "反差婊", icon: "ri-emotion-line", description: "人前人后两副面孔，反差人设大揭秘" },
  { slug: "guochan", name: "国产视频", icon: "ri-film-line", description: "国产原创爆料视频精选合集" },
  { slug: "zheng_neng_liang", name: "正能量", icon: "ri-heart-line", description: "正能量暖心故事，人间自有真情在" },
];

export const hotTags = ["独家", "今日大瓜", "热门", "视频", "新料", "必看"];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  tags: string[];
  imageSeq: string;
  imagePrompt: string;
  views: string;
  comments: string;
  date: string;
  isHot: boolean;
  isExclusive: boolean;
  content?: string;
  author?: string;
}

export const articles: Article[] = [
  {
    slug: "mou-ding-liu-nan-xing-chou-wen-bao-guang",
    title: "某顶流男星深夜密会神秘女子，酒店共度8小时",
    excerpt: "据知情人士爆料，该男星近期与一名圈外女子频繁约会，两人在酒店密会长达8小时，全程被拍到高清画面。",
    category: "wanghong",
    tags: ["独家", "今日大瓜"],
    imageSeq: "article-01",
    imagePrompt: "Dramatic night scene of a luxury hotel entrance with warm amber street lights, blurred figures at the doorway, moody atmosphere with deep shadows, cinematic composition, dark tones with golden accents, editorial photography style",
    views: "128万",
    comments: "3.2万",
    date: "2026-07-01",
    isHot: true,
    isExclusive: true,
    content: "据圈内知情人士透露，该顶流男星近期与一名圈外神秘女子关系密切...",
    author: "吃瓜前线记者",
  },
  {
    slug: "zhi-ming-nu-yan-yuan-hun-li-nei-mu",
    title: "知名女演员豪门婚礼内幕曝光，彩礼数额惊人",
    excerpt: "豪华婚礼背后隐藏着不为人知的家族博弈，彩礼数额据传高达九位数，引发全网热议。",
    category: "chaoyang",
    tags: ["今日大瓜"],
    imageSeq: "article-02",
    imagePrompt: "Luxurious wedding ceremony with elaborate floral arrangements, soft golden lighting, elegant banquet hall setting, romantic and opulent atmosphere, warm tones, shallow depth of field, editorial wedding photography",
    views: "96万",
    comments: "2.8万",
    date: "2026-06-30",
    isHot: true,
    isExclusive: false,
    content: "这场被外界称为'世纪婚礼'的盛典背后，有着许多不为人知的故事...",
    author: "娱乐八卦王",
  },
  {
    slug: "wang-hong-zhi-bo-jian-bei-ju-bao-feng-hao",
    title: "千万粉网红直播间被举报封号，疑似涉及虚假宣传",
    excerpt: "该网红在直播带货中被粉丝当场揭穿产品虚假宣传，随后直播间被大量举报导致封禁。",
    category: "wanghong",
    tags: ["热门"],
    imageSeq: "article-03",
    imagePrompt: "Close up of a smartphone screen showing a live streaming interface with bright colorful overlay, modern streaming setup with ring light, slightly blurred background, vibrant saturated tones, contemporary digital culture photography",
    views: "85万",
    comments: "4.1万",
    date: "2026-06-29",
    isHot: true,
    isExclusive: false,
    content: "一场原本平常的直播带货活动，却因为一个细心的粉丝彻底改变了走向...",
    author: "直播观察员",
  },
  {
    slug: "fan-cha-biao-nv-hai-xian-shi-sheng-huo-jie-mi",
    title: "反差婊女孩现实生活揭秘：白天白领晚上夜店女王",
    excerpt: "社交平台上清纯可人的女孩，现实中却过着截然不同的生活，身边好友爆料其真实面目。",
    category: "fanchabiao",
    tags: ["独家", "视频"],
    imageSeq: "article-04",
    imagePrompt: "Split scene composition showing contrast between professional office setting on left and vibrant nightclub atmosphere on right, dramatic lighting contrast, cinematic storytelling, moody tones, conceptual portrait photography",
    views: "156万",
    comments: "5.7万",
    date: "2026-06-28",
    isHot: true,
    isExclusive: true,
    content: "社交媒体上那个清纯可爱、不食人间烟火的女孩，究竟有着怎样不为人知的另一面？",
    author: "深度调查组",
  },
  {
    slug: "ding-jian-yi-ren-si-xia-sheng-huo-fang-fei-zi-wo",
    title: "知名艺人私下生活放纵，与荧幕形象判若两人",
    excerpt: "某知名艺人在私密聚会上的行为被曝光，完全颠覆了平日里温文尔雅的公众形象。",
    category: "chaoyang",
    tags: ["新料"],
    imageSeq: "article-05",
    imagePrompt: "Dimly lit private party scene with elegant interior, silhouettes and ambient lighting creating mystery, luxurious modern penthouse atmosphere, deep shadows with warm accent lighting, cinematic mood photography",
    views: "72万",
    comments: "2.1万",
    date: "2026-06-27",
    isHot: false,
    isExclusive: false,
    content: "平时在荧幕上温文尔雅、风度翩翩的他，在私人聚会中完全是另一副模样...",
    author: "私密线人",
  },
  {
    slug: "wang-bao-men-xin-wen-ji-zhe-an-fang-jie-lu",
    title: "网曝门新料：记者暗访揭露某高端会所内幕",
    excerpt: "记者伪装成会员潜入某高端私人会所，拍下了令人震惊的内部画面，涉及多位知名人士。",
    category: "wangbaomen",
    tags: ["独家", "必看"],
    imageSeq: "article-06",
    imagePrompt: "Mysterious entrance of an exclusive private club with subdued amber lighting, polished dark wood and brass details, sense of secrecy and exclusivity, cinematic noir atmosphere, rich dark tones with golden highlights",
    views: "201万",
    comments: "8.9万",
    date: "2026-06-26",
    isHot: true,
    isExclusive: true,
    content: "这家隐藏在繁华都市中的高端私人会所，究竟藏着什么不可告人的秘密？",
    author: "暗访调查组",
  },
  {
    slug: "kuo-qu-yuan-gong-bao-liao-chuang-ye-gong-si",
    title: "前员工爆料某明星创业公司内幕：加班如地狱",
    excerpt: "多名离职员工联合爆料某明星创办的科技公司内部混乱管理，996都算轻松的了。",
    category: "wanghong",
    tags: ["热门"],
    imageSeq: "article-07",
    imagePrompt: "Empty modern office at night with scattered documents and dim desk lamps, exhausted atmosphere, corporate environment with cold fluorescent lighting mixed with warm desk lamps, documentary style photography",
    views: "63万",
    comments: "1.5万",
    date: "2026-06-25",
    isHot: false,
    isExclusive: false,
    content: "表面光鲜亮丽的明星创业公司，内部管理竟然如此混乱不堪...",
    author: "职场观察家",
  },
  {
    slug: "du-jia-zheng-neng-liang-can-ji-ren-chuang-ye",
    title: "正能量：残疾小伙靠直播卖货年入千万，感动全网",
    excerpt: "一位身残志坚的95后小伙，通过直播带货不仅养活了自己，还带动了整个村子的经济发展。",
    category: "zheng_neng_liang",
    tags: ["必看"],
    imageSeq: "article-08",
    imagePrompt: "Inspiring scene of a determined young entrepreneur working at a simple desk setup with warm natural light streaming through window, rustic countryside background, hopeful and uplifting atmosphere, warm golden hour tones, documentary portrait photography",
    views: "189万",
    comments: "12.3万",
    date: "2026-06-24",
    isHot: true,
    isExclusive: false,
    content: "在很多人眼中，他是一个残疾人；但在更多人眼中，他是一个了不起的创业者...",
    author: "励志故事汇",
  },
  {
    slug: "guo-chan-duan-shi-pin-ping-tai-bei-yue-tan",
    title: "国产短视频平台再被约谈，内容审核形同虚设",
    excerpt: "某知名国产短视频平台因内容审核不力再次被监管部门约谈，平台方回应将全面整改。",
    category: "guochan",
    tags: ["今日大瓜"],
    imageSeq: "article-09",
    imagePrompt: "Modern corporate building exterior with subtle regulatory atmosphere, clean architectural lines, overcast sky creating serious mood, documentary architectural photography, muted color palette",
    views: "134万",
    comments: "3.6万",
    date: "2026-06-23",
    isHot: true,
    isExclusive: false,
    content: "这已经是该平台今年第三次被监管部门约谈了...",
    author: "行业观察",
  },
  {
    slug: "yi-qu-yu-le-quan-sheng-tai-jie-du",
    title: "娱乐圈一区生态解读：资本如何操控流量明星",
    excerpt: "深度解析娱乐圈一区的资本运作模式，揭秘流量明星背后的推手和利益链条。",
    category: "chaoyang",
    tags: ["深度"],
    imageSeq: "article-10",
    imagePrompt: "Abstract visualization of digital network connections with warm amber and gold nodes against dark background, representing complex systems and connections, modern data visualization aesthetic, sophisticated dark theme with glowing elements",
    views: "97万",
    comments: "2.4万",
    date: "2026-06-22",
    isHot: false,
    isExclusive: false,
    content: "在光鲜亮丽的娱乐圈背后，资本的触角无处不在...",
    author: "深度调查",
  },
  {
    slug: "er-qu-hai-jiao-she-qu-you-ren-wu-bao-liao",
    title: "二区海角社区又一人物被扒，身份令人意外",
    excerpt: "海角社区知名ID背后的真实身份被网友扒出，竟然是一位圈内知名人士的小号。",
    category: "wangbaomen",
    tags: ["独家", "今日大瓜"],
    imageSeq: "article-11",
    imagePrompt: "Mysterious anonymous figure silhouette against computer screen glow in dark room, hacker or online identity theme, dramatic chiaroscuro lighting, cyber mystery atmosphere, dark tones with monitor blue-white light, thriller photography style",
    views: "178万",
    comments: "6.5万",
    date: "2026-06-21",
    isHot: true,
    isExclusive: true,
    content: "海角社区一直是众多网友吃瓜的聚集地，而这次被扒出的ID让人大跌眼镜...",
    author: "海角观察员",
  },
  {
    slug: "san-qu-zui-xin-bao-liao-da-quan",
    title: "三区最新爆料大全：一周热点回顾",
    excerpt: "三区一周猛料汇总，涵盖网红八卦、明星绯闻、社会热点，一篇看完所有大瓜。",
    category: "fanchabiao",
    tags: ["必看", "热门"],
    imageSeq: "article-12",
    imagePrompt: "Collage style composition of newspaper headlines and digital news snippets, organized chaos aesthetic, warm paper tones mixed with modern digital elements, editorial layout photography, rich textures and layers",
    views: "210万",
    comments: "7.8万",
    date: "2026-06-20",
    isHot: true,
    isExclusive: false,
    content: "过去一周，娱乐圈和网红圈发生了太多令人瞠目结舌的事情...",
    author: "热点追踪",
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(slug: string, limit: number = 4): Article[] {
  const article = getArticleBySlug(slug);
  if (!article) return [];
  return articles.filter((a) => a.category === article.category && a.slug !== slug).slice(0, limit);
}